import { jsx as _jsx } from "react/jsx-runtime";
import ScrollableTabs from "segments/desktop/core-components/scrollable-tabs/scrollable-tabs.js";
import classnames from "classnames";
import { StyledUsecasesGalleryTabsDesktopComponent } from "/segments/desktop/tabs/layouts/usecases-gallery-tabs/usecases-gallery-tabs-desktop-component/usecases-gallery-tabs-desktop-component.scss";
const UsecasesGalleryTabsDesktopComponent = (props)=>{
    const { usecases, defaultSelectedTabLabel, alignToLogo, withDividerLine, selectedIconBackground, maxWidth, tabWidth, contentMarginTop, tabContentMaxWidth, iconSize, segmentType } = props;
    const defaultSelectedTabIndex = usecases === null || usecases === void 0 ? void 0 : usecases.findIndex((tab)=>{
        var _tab_label;
        return ((_tab_label = tab.label) === null || _tab_label === void 0 ? void 0 : _tab_label.toLocaleLowerCase()) === (defaultSelectedTabLabel === null || defaultSelectedTabLabel === void 0 ? void 0 : defaultSelectedTabLabel.toLocaleLowerCase());
    });
    return /*#__PURE__*/ _jsx(StyledUsecasesGalleryTabsDesktopComponent, {
        maxWidth: maxWidth,
        children: /*#__PURE__*/ _jsx("div", {
            className: classnames("usecases-gallery-tabs-desktop-component", {
                "align-to-logo": !!alignToLogo
            }),
            children: usecases && usecases.length > 0 ? /*#__PURE__*/ _jsx(ScrollableTabs, {
                tabs: usecases,
                defaultSelectedTabIndex: defaultSelectedTabIndex,
                withDividerLine: withDividerLine,
                selectedIconBackground: selectedIconBackground,
                tabWidth: tabWidth,
                contentMarginTop: contentMarginTop,
                tabContentMaxWidth: tabContentMaxWidth,
                iconSize: iconSize,
                segmentType: segmentType
            }) : /*#__PURE__*/ _jsx("div", {
                style: {
                    padding: "20px"
                },
                children: /*#__PURE__*/ _jsx("p", {
                    children: "No use cases available"
                })
            })
        })
    });
};
export default UsecasesGalleryTabsDesktopComponent;
